<template>
  <div>
    <v-layout v-if="isEmployee" column>
      <v-btn v-if="!pending && cancelled" disabled color="error">Cancelled!</v-btn>

      <v-btn v-if="pending" :loading="waiting" :disabled="waiting" @click="accept" color="success">Accept</v-btn>
      <v-btn v-if="!pending && accepted" disabled color="success">Accepted!</v-btn>

      <v-btn v-if="pending" :loading="waiting" :disabled="waiting" @click="reject" color="error">Reject</v-btn>
      <v-btn v-if="!pending && rejected" disabled color="error">Rejected!</v-btn>

      <v-btn v-if="shiftId" :to="{ name: 'shiftDetail', params: { shiftId: shiftId } }" color="primary">View Shift</v-btn>
      </v-flex>
    </v-layout>

    <v-layout v-else column>
      <v-btn v-if="!pending && accepted" disabled color="success">Accepted!</v-btn>
      <v-btn v-if="!pending && rejected" disabled color="error">Rejected!</v-btn>

      <v-btn v-if="pending" :loading="waiting" :disabled="waiting" @click="cancel" color="error">Cancel</v-btn>
      <v-btn v-if="!pending && cancelled" disabled color="error">Cancelled!</v-btn>

      <v-btn v-if="shiftId" :to="{ name: 'shiftDetail', params: { shiftId: shiftId } }" color="primary">View Shift</v-btn>
    </v-layout>
  </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  props: [
    'role',
    'pending',
    'accepted',
    'cancelled',
    'mustFulfill',
    'rejected',
    'shiftId',
  ],
  data () {
    return {
      waiting: false
    }
  },
  components: {
  },
  computed: {
    isEmployee () {
      return this.role == 'employee'
    },
  },
  methods: {
    reject () {
      this.$emit('reject')
    },
    accept () {
      this.$emit('accept')
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style scoped>
.pending-approval {

}
</style>
